import React from 'react';
import PropTypes from 'prop-types';

import AcceptIncomingCall from 'actions/phone_call/accept_incoming_call';
import ActiveCall from 'models/active_call';
import AgentProfile from 'models/agent_profile';
import Button, { ButtonTypes } from 'components/common/button';
import connect from 'components/lib/connect';
import DeclineIncomingCall from 'actions/phone_call/decline_incoming_call';
import DeclineWarmTransfer from 'actions/phone_call/decline_warm_transfer';
import { formatPhoneNumber } from 'models/phone_number';
import IncomingCallNotificationContent from './incoming_call_notification_content';
import Notification from './notification';
import PhoneCall from 'models/phone_call';

function IncomingCallNotification({
  activeCall,
  currentAgent,
  onAcceptIncomingCall,
  onDeclineIncomingCall,
  onDeclineWarmTransfer,
  routingGroupName,
  transferringAgentName,
}) {
  let currentAgentId = currentAgent.id;

  if (!activeCall || !activeCall.shouldDisplayIncomingCallNotification(currentAgentId)) {
    return null;
  }

  let phoneCall = activeCall.conversationItem.content;
  let incomingCallType = phoneCall.getIncomingCallType(currentAgentId);

  let customerDisplayName = activeCall.customer.name
    ? activeCall.customer.name
    : formatPhoneNumber(phoneCall.customerNumber);

  return (
    <Notification contentClasses="incomingCallNotification" notificationId={activeCall.conversationItem.id}>
      <IncomingCallNotificationContent
        customerDisplayName={customerDisplayName}
        incomingCallType={incomingCallType}
        routingGroupName={routingGroupName}
        transferringAgentName={transferringAgentName}
      />
      <div className="notification-buttonContainer">
        {currentAgent.isConfiguredForInteractiveVoice() ? renderDecline(incomingCallType) : null}
        {renderAccept()}
      </div>
    </Notification>
  );

  function renderAccept() {
    if (currentAgent.isConfiguredForInteractiveVoice() && currentAgent.usesExternalHandset()) {
      return <span className="conversationNotification-acceptMessage">Answer using handset</span>;
    }

    return (
      <Button
        buttonType={ButtonTypes.PRIMARY}
        className="notification-button conversationNotification-acceptButton"
        onClick={onClickAccept}
      >
        Accept
      </Button>
    );
  }

  function renderDecline() {
    return (
      <Button
        buttonType={ButtonTypes.TEXT}
        contrast
        className="notification-button conversationNotification-declineButton"
        onClick={isWarmTransfer(incomingCallType) ? onDeclineWarmTransfer : onDeclineIncomingCall}
      >
        Decline
      </Button>
    );
  }

  function onClickAccept(ev) {
    ev.stopPropagation();
    onAcceptIncomingCall();
  }

  function isWarmTransfer() {
    return incomingCallType === PhoneCall.IncomingCallType.WARM_TRANSFER;
  }
}

IncomingCallNotification.propTypes = {
  activeCall: PropTypes.instanceOf(ActiveCall),
  currentAgent: PropTypes.instanceOf(AgentProfile),
  onAcceptIncomingCall: PropTypes.func.isRequired,
  onDeclineIncomingCall: PropTypes.func.isRequired,
  onDeclineWarmTransfer: PropTypes.func.isRequired,
  routingGroupName: PropTypes.string,
  transferringAgentName: PropTypes.string,
};

function mapStateToProps({ getProvider }) {
  const activeCall = getProvider('activeCall').get();
  let transferringAgentName;
  let routingGroupName;
  let currentAgent = getProvider('currentAgent').get();
  if (activeCall) {
    if (activeCall.initiator) {
      let transferringAgent = getProvider('agents').find(activeCall.initiator.agentId);
      transferringAgentName = transferringAgent.name || transferringAgent.email;
      routingGroupName = getProvider('routingGroups').findBy({ id: activeCall.initiator.routingGroupId }).name;
    }
    if (activeCall.routingGroupId) {
      routingGroupName = getProvider('routingGroups').findBy({ id: activeCall.routingGroupId }).name;
    }
  }

  return {
    activeCall,
    currentAgent,
    routingGroupName,
    transferringAgentName,
  };
}

function mapExecuteToProps(executeAction) {
  return {
    onAcceptIncomingCall: () => executeAction(AcceptIncomingCall),
    onDeclineIncomingCall: () => executeAction(DeclineIncomingCall),
    onDeclineWarmTransfer: () => executeAction(DeclineWarmTransfer),
  };
}

const IncomingCallNotificationContainer = connect(mapStateToProps, mapExecuteToProps)(IncomingCallNotification);

export { IncomingCallNotification };
export default IncomingCallNotificationContainer;



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/notification/incoming_call_notification.jsx